import PanelNew from '@/containers/SubscriptionFormPageNew/Panel/PanelNew'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import SDModal from '@/shared/components/SDComponentsNewDesign/SDModal/SDModal'
import logo from '@/containers/SubscriptionFormPageNew/Components/Contact/user.svg'
import SalesScriptContent from './SalesScriptContent'
import useSalesScript from './useSalesScript'
import { ButtonsColumn } from './styled-components'

const SalesScript = () => {
  const {
    hidden,
    title,
    emptyText,
    isOpen,
    energyLabel,
    telecomLabel,
    modalTitle,
    content,
    isEmpty,
    openEnergyScript,
    openTelecomScript,
    closeModal,
  } = useSalesScript()

  if (hidden) return null

  return (
    <PanelNew
      alt={title}
      logo={logo}
      title={title}
      id='SalesScriptModule'
    >
      <ButtonsColumn>
        {/* @ts-ignore */}
        <SDButton block onClick={openEnergyScript}>
          {energyLabel}
        </SDButton>
        {/* @ts-ignore */}
        <SDButton block onClick={openTelecomScript}>
          {telecomLabel}
        </SDButton>
      </ButtonsColumn>
      <SDModal
        isOpen={isOpen}
        openHandler={closeModal}
        title={modalTitle}
        sections={
          <SalesScriptContent
            content={content}
            isEmpty={isEmpty}
            emptyText={emptyText}
          />
        }
      />
    </PanelNew>
  )
}

export default SalesScript
